export const AMERICAN_ROULETTE_WHEEL = [
  "0",
  "28",
  "9",
  "26",
  "30",
  "11",
  "7",
  "20",
  "32",
  "17",
  "5",
  "22",
  "34",
  "15",
  "3",
  "24",
  "36",
  "13",
  "1",
  "00",
  "27",
  "10",
  "25",
  "29",
  "12",
  "8",
  "19",
  "31",
  "18",
  "6",
  "21",
  "33",
  "16",
  "4",
  "23",
  "35",
  "14",
  "2",
];

export const ROULETTE_RED_NUMBERS = new Set([
  "1",
  "3",
  "5",
  "7",
  "9",
  "12",
  "14",
  "16",
  "18",
  "19",
  "21",
  "23",
  "25",
  "27",
  "30",
  "32",
  "34",
  "36",
]);

export function getRouletteWheelPocketIndex(value) {
  return AMERICAN_ROULETTE_WHEEL.indexOf(String(value));
}

export function getRouletteWheelPocketColour(value) {
  const pocket = String(value);

  if (pocket === "0" || pocket === "00") {
    return "green";
  }

  return ROULETTE_RED_NUMBERS.has(pocket) ? "red" : "black";
}

export function getRouletteWheelPocketAngle(value) {
  const index = getRouletteWheelPocketIndex(value);

  if (index < 0) {
    return 0;
  }

  return (index / AMERICAN_ROULETTE_WHEEL.length) * Math.PI * 2;
}
